import moment from 'moment';

export interface MonthYear {
    month: string;
    year: number;
}

export function getMonthsYearBetweenDates(
    startDate: moment.Moment | Date,
    endDate: moment.Moment | Date,
): MonthYear[] {
    const monthYear: MonthYear[] = [];
    const start = moment(startDate);
    const end = moment(endDate);

    // ensure start is before end
    if (start.isAfter(end)) {
        throw new Error('Start date must be before end date');
    }

    const current = start.clone();

    while (current.isSameOrBefore(end)) {
        monthYear.push({
            month: current.format('MMMM'),
            year: current.year(),
        });

        current.add(1, 'month');
    }

    return monthYear;
}

